import './corn&ryespirits2/style';
import FormStructure from './corn&ryespirits2/form_structure';

export default FormStructure;